/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snippet_Destroy_CommentInputs */

const fr_snippet_destroy_comment = /** @type {(inputs: Snippet_Destroy_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour détruire le widget plus tard :`)
};

const en_snippet_destroy_comment = /** @type {(inputs: Snippet_Destroy_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To destroy the widget later:`)
};

/**
* | output |
* | --- |
* | "To destroy the widget later:" |
*
* @param {Snippet_Destroy_CommentInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const snippet_destroy_comment = /** @type {((inputs?: Snippet_Destroy_CommentInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snippet_Destroy_CommentInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snippet_destroy_comment(inputs)
	return en_snippet_destroy_comment(inputs)
});